  <ul class="list-unstyled mb-0">
    <li class="list-inline-item" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="onClick(i+1)" [matTooltip]="ratingId+1">
        <i class="mdi mdi-star "[ngClass]="{'text-warning': showIcon(i) == true}"></i>
    </li>

</ul>
  <!-- <p class="body-2">
      Your rated <span class="body-2">{{rating}}</span> / <span class="body-2">{{starCount}}</span>
  </p>
   -->